// extracted by mini-css-extract-plugin
export default {"ImgPreview":"_ecvi","ImgPreview__spinner":"qSxLN","ImgPreview__img":"ybYnE","ImgPreview__img_loaded":"zjewi","ImgPreview__placeholder":"sLxcM"};